import {
  patchState,
  signalStoreFeature,
  type,
  withComputed,
  withMethods,
} from '@ngrx/signals';
import { ActiveUserState, GuestAccessConfig } from './active-user.state';
import { Bookmark } from '../../models/bookmark';
import { computed } from '@angular/core';

export function withGuestUserSelectors() {
  return signalStoreFeature(
    {
      state: type<ActiveUserState>(),
    },
    withComputed(({ user, guestAccessConfig, context }) => ({
      /**
       * Check if current session is a guest view
       */
      isGuestView: computed(() => context() === 'guestView'),

      /**
       * Get guest token for API requests
       */
      guestToken: computed(() => guestAccessConfig()?.token || undefined),

      /**
       * Check if user can access a specific indicator in guest mode
       */
      canAccessIndicator: computed(() => (indicatorId: string) => {
        if (context() !== 'guestView') return true; // Not in guest mode
        const config = guestAccessConfig();
        return config?.allowedIndicators.includes(indicatorId) ?? false;
      }),

      /**
       * Check if user can access a specific data layer in guest mode
       */
      canAccessDataLayer: computed(() => (layerId: string) => {
        if (context() !== 'guestView') return true; // Not in guest mode
        const config = guestAccessConfig();
        return config?.allowedDataLayers.includes(layerId) ?? false;
      }),
    })),
    withMethods(store => ({
      setGuestAccessConfig(
        bookmark: Bookmark,
        allowedIndicators: string[],
        allowedDataLayers: string[]
      ): void {
        if (!bookmark.guestLink?.enabled) {
          console.warn('Bookmark does not have guest access enabled');
          //return;
        }

        // Extract indicators and data layers from bookmark config
        const guestConfig: GuestAccessConfig = {
          entityType: 'Bookmark',
          entityId: bookmark._id,
          entity: bookmark as Bookmark,
          //token: bookmark.guestLink.token,
          allowedIndicators,
          allowedDataLayers,
          layoutOptions: bookmark.layoutOptions,
          //expiresAt: bookmark.guestLink.expiresAt,
        };

        patchState(store, {
          guestAccessConfig: guestConfig,
          //guestToken: bookmark.guestLink.token,
          context: 'guestView',
          commune: bookmark.commune || '',
        });
      },

      /**
       * Sets guest access config directly (for Guard usage)
       * @param config The pre-validated guest access configuration
       */
      setGuestAccessConfigDirect(config: GuestAccessConfig): void {
        patchState(store, {
          guestAccessConfig: config,
          //guestToken: config.token || undefined,
          context: 'guestView',
        });
      },

      /**
       * Clears guest access configuration
       */
      clearGuestAccessConfig(): void {
        patchState(store, {
          guestAccessConfig: undefined,
          //guestToken: undefined,
          context: 'dataBackend',
        });
      },
    }))
  );
}
